import { render, staticRenderFns } from "./LeftoversMobile.vue?vue&type=template&id=63e94830&scoped=true&"
import script from "./LeftoversMobile.vue?vue&type=script&lang=js&"
export * from "./LeftoversMobile.vue?vue&type=script&lang=js&"
import style0 from "./LeftoversMobile.vue?vue&type=style&index=0&id=63e94830&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e94830",
  null
  
)

export default component.exports